import {Base} from "@/api/Base"

export class SalaryList extends Base {
    path = "salary/list"
}